var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(12695 498)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12695 -498)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12695.256 497.295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.687,24.869a9.189,9.189,0,0,0,1.045-.627h.313l6.687,6.687a1.218,1.218,0,0,1,.209.731v1.045H16.3V31.66a1.29,1.29,0,0,1,.418-.836c1.881-1.985,3.866-3.866,5.747-5.747.94-.94.94-.94,2.09-.313.522.313.94.418,1.358,0s.313-.836.1-1.358c-.418-.94-.94-1.985-1.358-2.926-.731-1.567-1.985-1.776-3.239-.627l-4.6,4.6h0a.314.314,0,0,1-.522-.209V19.853a.466.466,0,0,1,.418-.313,5.312,5.312,0,0,0,3.448-2.508,12.635,12.635,0,0,0,1.985-6.06A1.348,1.348,0,0,0,20.48,9.4h0c-.209,0-.313,0-.418-.313-.1-.94-.209-1.776-.313-2.612a10.229,10.229,0,0,0-1.672-4.284c-1.463-1.985-3.448-1.985-4.911,0a9.539,9.539,0,0,0-.836,1.358A21.155,21.155,0,0,0,11.389,7a11.573,11.573,0,0,0-.209,1.985c0,.209-.209.313-.418.313h-.1c-1.254-.209-1.776.209-1.567,1.463a24.3,24.3,0,0,0,.836,3.762c.836,2.4,2.194,4.389,4.807,4.911.1,0,.209.209.209.313v4.284a.293.293,0,0,1-.522.209,1.442,1.442,0,0,1-.313-.418h0c-1.045-1.045-3.762-3.762-4.493-4.389a1.7,1.7,0,0,0-2.717.522A21.58,21.58,0,0,0,5.329,23.51a1.531,1.531,0,0,0,.209,1.149c.313.418.731.418,1.254.1Zm9.718,2.4c0-.209.209-.418.313-.627,1.881-1.985,3.866-3.866,5.747-5.747.522-.522.731-.418,1.045.209.209.522.522,1.045.731,1.672,0,.1,0,.209-.209.209-.836-.418-1.358.1-1.985.731l-5.433,5.433s-.209,0-.209-.1Zm4.284-16.4s.209,0,.209.1c.313,2.717-1.985,6.687-4.284,7.21,0,0-.209,0-.209-.1C15.987,15.36,18.495,11.285,20.689,10.867Zm-5.747,7.419a.145.145,0,0,1-.209,0,8.422,8.422,0,0,1-1.881-1.254c-1.672-1.672-2.09-3.866-2.4-6.165a.2.2,0,0,1,.209-.209c2.3.418,4.911,4.6,4.389,7.419Zm-1.567-7.523v-.209c.209-.209.627-.522.627-.731,0-.836-.731-.522-1.254-.627a.1.1,0,0,1-.1-.1V8.777a.1.1,0,0,1,.1-.1c.522-.1,1.358,0,1.149-1.045,0-.209-.522-.313-.94-.522V6.9s.1-.209.209-.209c.418,0,.836-.1.836-.627,0-.313-.418-.522-.627-.836V5.016A10.885,10.885,0,0,1,14.42,3.135a1.48,1.48,0,0,1,2.612,0,12.44,12.44,0,0,1,.94,1.567v.313a2.365,2.365,0,0,0-.418.94c0,.209.522.418.731.627.1,0,.209.209.313.313v.209c-.522.1-1.149.1-.94.836,0,.313.522.522.94.731l.209.209v.209c-.418.209-.94.313-1.045.627-.209.522,0,.731.522.836.1,0,.209.209,0,.209L16.718,12.33h0c-.1.627-.418,1.045-1.149.94a.417.417,0,0,1-.418-.209c-.627-.836-1.254-1.567-1.776-2.3ZM7.105,22.779c.313-.627.522-1.149.836-1.672.313-.627.522-.731,1.045-.209.627.522,3.344,3.344,4.284,4.284h0l.1.1h0l1.463,1.463a.888.888,0,0,1,.313.522V28.63a.293.293,0,0,1-.522.209h0L9.091,23.3a1.058,1.058,0,0,0-1.567-.209c-.1,0-.313,0-.209-.209Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.181,5.016Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.122,8.464v0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.27,5.016Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.614,12.225a1.485,1.485,0,0,1-.627.209c-.522.1-1.463,0-1.254-.731.209-.627,1.567-.731,1.985-.209a.657.657,0,0,1,0,.627h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.778,10.658a.915.915,0,0,1-.94-.836c0-.418.418-.522.836-.522.313,0,.836,0,1.045.209.313.522-.313,1.045-.836,1.045h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.778,7.105c.418,0,1.045.313.94.836,0,.522-.522.522-.94.522s-.836,0-.94-.418c-.209-.522.418-.94.94-.94Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.882,5.224c.522,0,1.149.418.836.94-.209.313-.627.313-.94.313-.418,0-.731,0-.94-.313-.313-.627.418-1.045,1.045-.94h0Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.778,4.493c-1.254,0-1.463-1.463,0-1.358.418,0,.836,0,.94.418.209.522-.418.94-.94.94Z",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilho);
export default __webpack_public_path__ + "static/media/milho.041fbe3dda18156a862e4dea979a6347.svg";
export { ForwardRef as ReactComponent };